export default "__VITE_ASSET__CaBtks2U__"